import * as yup from 'yup'

import { createDataRef, createDataSchema } from '../schemaUtils'
import * as linkSchemas from '../link/Link.schema'

export const vectorImageDataSchema = createDataSchema(
	'VectorImage',
	yup.object({
		link: createDataRef(linkSchemas).nullable(),
		alt: yup.string(),
		title: yup.string().max(100),
		svgId: yup.string(),
	})
)
